import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import Prices from "./sections/Prices";
import MusculoskeletalPricing from "./sections/MusculoskeletalPricing";
import PelvicPricing from "./sections/PelvicPricing";
import MassagePricing from "./sections/MassagePricing";
import CallAction from "./sections/CallAction";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <Prices />
      <MusculoskeletalPricing />
      <PelvicPricing />
      <MassagePricing />
      <CallAction />
      <Footer />
    </div>;
}